"use client";

import { useSelector } from "react-redux";
import { symbolData } from "@/constants/symbol";

const CurrencyConverter = ({ amount }) => {
  const currencyMeta = useSelector((state) => state.general.currencyMeta);
  const currentSymbol = symbolData[currencyMeta.code];
  const cCode = currencyMeta.code;

  const cAmount = Math.floor(amount * currencyMeta.rate)
  .toLocaleString("en-IN", {
    style: "currency",
    currency: cCode === "QR" ? "QAR": cCode,
    minimumFractionDigits: 0,
  }).replace(/[^0-9,]/g, '');

  return (
    <span>
      {currentSymbol}
      {cAmount}
    </span>
  );
};

export default CurrencyConverter;
